import React from 'react'
import { useSelector } from 'react-redux'
import CommonActorDetailHeader from '@EUForms/parties/commonActorDetailHeader'

const ActorDetailHeader = ({ merchandiseId, tableName, ...rest }) => {
    const actorName = useSelector(state => state.invoiceReducer.invoice.merchandiseMap[merchandiseId]?.merchandiseParties?.[tableName]?.[0]?.name)?.toUpperCase() || ''
    return (<CommonActorDetailHeader name={actorName} {...rest} />)
}

export default ActorDetailHeader